export default __webpack_public_path__ + "static/media/dropbox.a42a5062.svg";